import 'amazon-connect-streams';
// D21 (defect log 2026-08-26, 2026-09-08): MUST follow the Streams import.
// Streams' TaskMediaController calls connect.TaskSession.create(), which this
// package attaches to the global `connect`. Without it every task-contact
// accessor (getInitialConnection, getAgentConnection, isInbound) throws and
// no task can be accepted or ended from this console.
import 'amazon-connect-taskjs';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/globals.css';
import './styles/login.css';
import './styles/callbacks-history.css';
import './styles/coaching.css';
import './styles/live-copilot.css';
import './styles/transfer-panel.css';
import './styles/live-transcript.css';
import './styles/softphone.css';
import './styles/acw.css';
// Console v4 look (row 234). Every rule is scoped to .ui-v4, so it does nothing
// until the hidden switch (?ui=v4) is on. Imported last so it wins ties.
import './styles/ui-v4.css';
import { uiFlags } from './lib/uiFlag';

// The switch goes on <html>, before the first render, so the v4 tokens apply
// from the first paint (no v3 flash) and App.jsx's shell markup is untouched.
const ui = uiFlags();
if (ui.v4) document.documentElement.classList.add('ui-v4');
if (ui.light) document.documentElement.classList.add('ui-light');

createRoot(document.getElementById('root')).render(<App />);
